import { getDetaileMoreProducts, intlNumber } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/components/ProductComponents';
import TextModule from '@/components/ProductDetailComponents/TextModule';
import TextOnImage from '@/components/ProductDetailComponents/TextOnImage';
import TextWithImage from '@/components/ProductDetailComponents/TextWithImage';
import SwitchTabIcon from '@/components/ProductDetailComponents/SwitchTabIcon';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import OtherList from '@/components/ProductCommon/OtherList';
const webpUrl = '/media/delta/pc/';
const { EFPic } = createEFPic(webpUrl);

export default function () {
    const { useLang, gloproductlist, useRouter } = useGlobal();
    const { locale } = useRouter();
    const imageLocal = getImageLocal(locale, ['jp', 'de', 'cn']);
    const { t } = useLang('delta_new');

    const isAr = locale == 'sa';
    const getFinalUnit = (baseUnit: string, arabUnit: string) => {
        return isAr ? arabUnit : baseUnit;
    };

    const text3 = {
        text: t('capacity'),
    };

    const text4 = {
        text: t('capacity_sub_title'),
    };

    const text5 = {
        text: t('capacity_desc'),
    };

    const text6 = {
        text: t('capacity_notice'),
    };

    const text7 = {
        text: t('AC_output'),
    };

    const text8 = {
        text: t.raw('AC_output_sub_title'),
    };

    const text9 = {
        text: t.raw('AC_output_desc'),
    };

    const text10 = {
        text: t('AC_output_notice'),
    };

    const text11 = {
        text: t('caught_in_dark'),
    };

    const text12 = {
        text: t('caught_in_dark_desc'),
    };

    const text13 = {
        text: t('caught_in_dark_notice'),
    };

    const textStyle2 = {
        textAlign: 'center',
        backColor: 'transparent',
        margin: '0 auto',
        lineHeight: '40px',
        fontSize: '32px',
        color: '#fff',
        fontFamily: 'var(--font-family-Medium)',
        fontWeight: 500,
    };

    const textStyle3 = {
        type: 'ls',
        textAlign: 'center',
        backColor: 'transparent',
        color: '#fff',
        margin: '10px auto 40px',
        whiteSpace: 'pre-wrap',
    };

    const textStyle4 = {
        width: '924px',
        fontSize: '22px',
        lineHeight: '1.55',
        textAlign: 'center',
        backColor: 'transparent',
        color: '#999',
        margin: '10px auto 40px',
        fontFamily: 'var(--font-family-SemiBold)',
        fontWeight: 600,
    };

    const textStyle41 = {
        width: '924px',
        fontSize: '22px',
        lineHeight: '1.55',
        textAlign: 'center',
        backColor: 'transparent',
        color: '#999',
        fontWeight: locale === 'cn' ? 500 : 600,
    };

    const textStyle5 = {
        fontSize: '17px',
        opacity: 1,
        lineHeight: '1.55',
        color: '#777',
        textAlign: 'center',
        margin: '0 auto',
        backColor: 'transparent',
    };

    const textStyle6 = {
        width: '924px',
        fontSize: '64px',
        lineHeight: '1.13',
        textAlign: 'center',
        backColor: 'transparent',
        color: '#fff',
    };

    const item1 = {
        title: '',
        synopsis: t('charging_faster'),
        desc: t('charging_faster_desc'),
        footerNote: t('charging_faster_notice'),
        bgImgs: [`4_main_${imageLocal}.webp`, `4_main_${imageLocal}.jpg`],
        icon: '/media/delta/pc/4_main_icon.svg',
        newWindLink: '/x-stream',
        linkDesc: t('x_stream_link'),
        arr: [
            {
                num: intlNumber(locale, 3.5),
                eum: t('Hrs'),
                desc: t('charging_faster_desc2'),
            },
            {
                num: intlNumber(locale, 1.6),
                eum: t('Hrs'),
                desc: t('charging_faster_desc3'),
            },
        ],
    };

    const item2 = {
        img_url: ['6_main.webp', '6_main.jpg'],
        synopsis: t('pure_power'),
        desc: t('pure_power_desc'),
    };

    const switchIconData = {
        title1: t('switch_tab_title1'),
        title2: t('switch_tab_title2'),
        list: [
            {
                key: 0,
                title: t('home_backup'),
                content: [
                    {
                        icon: '/media/deltamax/pc/useTime/homeBc01.svg',
                        device: 'Light',
                        usageTime: [{ time: 30, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/homeBc03.svg',
                        device: 'Refrigerator',
                        usageTime: [{ time: `${intlNumber(locale, 6.3)}-${intlNumber(locale, 12.6)}`, unit: getFinalUnit(t('Hrs'), t('Hrs4')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/homeBc04.svg',
                        device: 'Microwave',
                        usageTime: [
                            {
                                time: intlNumber(locale, 0.9),
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/homeBc05.svg',
                        device: 'Washer',
                        usageTime: [{ time: intlNumber(locale, 2.1), unit: getFinalUnit(t('Hrs'), t('Hrs4')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/homeBc06.svg',
                        device: 'Electric Frying Pan',
                        usageTime: [
                            {
                                time: intlNumber(locale, 0.9),
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/homeBc07.svg',
                        device: '50" TV',
                        usageTime: [{ time: 13, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/homeBc08.svg',
                        device: 'Hair Dryer',
                        usageTime: [
                            {
                                time: intlNumber(locale, 0.7),
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/homeBc09.svg',
                        device: 'Coffee Maker',
                        usageTime: [{ time: intlNumber(locale, 1.1), unit: getFinalUnit(t('Hrs'), t('Hrs4')) }],
                    },
                ],
            },
            {
                key: 1,
                title: t('off_life'),
                content: [
                    {
                        icon: '/media/deltamax/pc/useTime/offGL01.svg',
                        device: 'Phone',
                        usageTime: [{ time: 104, unit: getFinalUnit(t('Times'), t('Times1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/offGL02.svg',
                        device: 'Laptop',
                        usageTime: [{ time: 19, unit: getFinalUnit(t('Times'), t('Times1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/offGL03.svg',
                        device: 'Camera',
                        usageTime: [{ time: 70, unit: getFinalUnit(t('Times'), t('Times1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/offGL04.svg',
                        device: 'Drone',
                        usageTime: [{ time: 29, unit: getFinalUnit(t('Times'), t('Times1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/offGL05.svg',
                        device: 'Speaker',
                        usageTime: [{ time: 36, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/offGL06.svg',
                        device: 'Blender',
                        usageTime: [{ time: intlNumber(locale, 2.1), unit: getFinalUnit(t('Hrs'), t('Hrs4')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/offGL07.svg',
                        device: 'Car Fridge',
                        usageTime: [{ time: '19-38', unit: getFinalUnit(t('Hrs'), t('Times1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/offGL08.svg',
                        device: 'Projector',
                        usageTime: [{ time: 13, unit: getFinalUnit(t('Hrs'), t('Times1')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/offGL09.svg',
                        device: 'PS5',
                        usageTime: [{ time: intlNumber(locale, 2.1), unit: getFinalUnit(t('Hrs'), t('Hrs4')) }],
                    },
                ],
            },
            {
                key: 2,
                title: t('professional'),
                content: [
                    {
                        icon: '/media/deltamax/pc/useTime/professional01.svg',
                        device: 'Circular Saw',
                        usageTime: [
                            {
                                time: intlNumber(locale, 0.8),
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/professional02.svg',
                        device: 'Air Conditioner',
                        usageTime: [{ time: `${intlNumber(locale, 0.6)}-${intlNumber(locale, 1.2)}`, unit: getFinalUnit(t('Hrs'), t('Hrs4')) }],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/professional03.svg',
                        device: 'Electric Hammer',
                        usageTime: [
                            {
                                time: intlNumber(locale, 0.9),
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/professional04.svg',
                        device: 'Electric Drill',
                        usageTime: [
                            {
                                time: 1,
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs1')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/professional05.svg',
                        device: 'Cutting Machine',
                        usageTime: [
                            {
                                time: 1,
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs1')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/professional06.svg',
                        device: 'Electric Oven',
                        usageTime: [
                            {
                                time: intlNumber(locale, 0.7),
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/professional07.svg',
                        device: 'Electric Grill',
                        usageTime: [
                            {
                                time: intlNumber(locale, 0.9),
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                            },
                        ],
                    },
                    {
                        icon: '/media/deltamax/pc/useTime/professional08.svg',
                        device: 'Air Fryer',
                        usageTime: [
                            {
                                time: intlNumber(locale, 0.7),
                                unit: getFinalUnit(locale === 'de' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                            },
                        ],
                    },
                ],
            },
        ],
    };

    const product: any = {
        us: ['product_ps_delta_delta_mini', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_pro'],
        cn: ['product_ps_delta_delta_2', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_pro'],
        za: ['product_ps_delta_delta_1300', 'product_ps_delta_delta_pro', 'product_ps_river_river_pro_720'],
    };

    const otherProductData = getDetaileMoreProducts(gloproductlist, product[locale] || product.us);

    return (
        <>
            <LineSpace height={120} background="transparent" />
            <div className="section2">
                <div className="left">
                    <div className="top box">
                        <EFPic name={['DELTA_web_1.png', 'DELTA_web_1.webp']} alt={t('second_ac_output')} aria-label={t('second_ac_output')} />
                        <p className="num">{t('second_ac_output_value')}</p>
                        <p className="tit">{t('second_ac_output')}</p>
                    </div>
                    <div className="bottom">
                        <div className="bot-left box">
                            <EFPic
                                name={['DELTA_web_4.png', 'DELTA_web_4.webp']}
                                alt={t('second_solar_charging_value')}
                                aria-label={t('second_solar_charging_value')}
                            />
                            <p className="num">{t('second_solar_charging_value')}</p>
                            <p className="tit">{t('second_solar_charging')}</p>
                        </div>
                        <div className="bot-right box">
                            <EFPic name={['DELTA_web_3.webp', 'DELTA_web_3.png']} alt={t('second_ac_fast_input')} aria-label={t('second_ac_fast_input')} />
                            <p className="num">{`${intlNumber(locale, 1.6)}${locale === 'de' ? ' Stunden' : 'h'}`}</p>
                            <p className="tit">{t('second_ac_fast_input')}</p>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="top box">
                        <EFPic name={['DELTA_web_2.webp', 'DELTA_web_2.png']} alt={t('second_bms')} aria-label={t('second_bms')} />
                        <p className="tit">{t('second_bms')}</p>
                    </div>
                    <div className="bottom box">
                        <EFPic name={['DELTA_web_6.webp', 'DELTA_web_6.png']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <p className="tit">
                            {t.rich('second_capacity', {
                                brMark: (child: string) => <span className="second_capacity_br">{child}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
            <LineSpace height={300} background="transparent" />
            <TextModule data={text3} cssStyle={textStyle2} />
            <TextModule data={text4} cssStyle={textStyle3} />
            <div className="textModule5">
                <TextModule
                    data={text5}
                    cssStyle={{
                        ...textStyle4,
                        fontClass: 'preWrap',
                        lineHeight: '34px',
                        margin: '0 auto 40px',
                        width: locale === 'cn' ? '560px' : '924px',
                    }}
                />
            </div>
            <TextModule data={text6} cssStyle={{ ...textStyle5, lineHeight: '28px' }} />
            <LineSpace height={120} background="transparent" />
            <div className="switch-tab">
                <SwitchTabIcon data={switchIconData} langKey="delta_new" />
            </div>
            <LineSpace height={300} background="transparent" />
            <TextModule data={text7} cssStyle={textStyle2} />
            <TextModule data={text8} cssStyle={textStyle3} />
            <div className="textModule9">
                <TextModule data={text9} cssStyle={{ ...textStyle4, margin: '0 auto 32px' }} />
            </div>
            <TextModule data={text10} cssStyle={{ ...textStyle5, fontWeight: locale === 'cn' ? 400 : 600 }} />
            <LineSpace height={80} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '1080px',
                    margin: '0 auto',
                }}
            >
                <EFPic name={['3_main.webp', '3_main.jpg']} className="fullImgs" alt={t('1800W AC Output')} />
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="textOnImg1">
                <TextOnImage
                    data={item1}
                    config={{
                        position: locale == 'sa' ? 'right' : 'left',
                        titleColor: '#ededed',
                        synopsisColor: '#fff',
                        descColor: '#999',
                        itemsDescColor: '#919191',
                        itemsPhraseColor: '#919191',
                        iconWidth: '115',
                        iconHeight: '33',
                        itemsColor: '#fff',
                        isWebp: true,
                        webpUrl,
                        synopsisFontSize: (() => {
                            const map = {
                                it: '52',
                                jp: '52',
                                fr: '52',
                            };
                            return map[locale as keyof typeof map] || '64';
                        })(),
                        descFontSize: (() => {
                            const map = {
                                it: '19',
                            };
                            return map[locale as keyof typeof map] || '22';
                        })(),
                        width: (() => {
                            const map = {
                                it: '550px',
                            };
                            return map[locale as keyof typeof map] || '550px';
                        })(),
                    }}
                />
            </div>
            <LineSpace height={210} background="transparent" />
            <TextModule data={text11} cssStyle={textStyle6} />
            <LineSpace height={40} background="transparent" />
            <div className="textModule12">
                <TextModule data={text12} cssStyle={textStyle41} />
            </div>
            <LineSpace height={32} background="transparent" />
            <TextModule data={text13} cssStyle={{ ...textStyle5, fontWeight: locale === 'cn' ? 400 : 600 }} />
            <LineSpace height={80} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '1280px',
                    height: '720px',
                    margin: '0 auto',
                }}
            >
                <EFPic name={['5_main.webp', '5_main.jpg']} className="fullImgs" alt={t('delta_dark')} />
            </div>
            <LineSpace height={180} background="transparent" />
            <div style={{ display: 'flex', justifyContent: 'center' }} className="textWithImg1">
                <TextWithImage
                    data={item2}
                    config={{
                        padding: '130px 0',
                        position: 'right',
                        titleColor: '#fff',
                        synopsisColor: '#fff',
                        descColor: '#999',
                        phraseColor: 'rgba(145, 145, 145)',
                        isWebp: true,
                        webpUrl,
                        synopsisFontSize: (() => {
                            const map = {
                                it: '52',
                                cn: '60',
                            };
                            return map[locale as keyof typeof map] || '64';
                        })(),
                        descFontSize: (() => {
                            const map = {
                                it: '19',
                            };
                            return map[locale as keyof typeof map] || '22';
                        })(),
                        width: (() => {
                            const map = {
                                it: '550px',
                            };
                            return map[locale as keyof typeof map] || '550px';
                        })(),
                    }}
                />
            </div>
            <LineSpace height={130} background="transparent" />
            <OtherList data={otherProductData} theme="black" />
        </>
    );
}
